/** Online reservation + public price are opt-in per stay. Missing/false = info only. */
export function isStayReservable(stay: { allowReservation?: boolean } | null | undefined): boolean {
  return stay?.allowReservation === true;
}
